import {inject} from "@angular/core";
import {HttpErrorResponse, HttpInterceptorFn} from "@angular/common/http";
import {AuthService, ConfigurationService} from "@shared/api";
import {catchError, switchMap, throwError} from "rxjs";

export const authInterceptor: HttpInterceptorFn = (req, next) => {
    const configService = inject(ConfigurationService);
    const authService = inject(AuthService);

    const apiUrl = configService.getValue("apiUrl") as string;
    const oAuthUrl = configService.getValue("oAuthUrl") as string;

    const shouldAttachToken = req.url.startsWith(apiUrl) || req.url.startsWith(oAuthUrl);

    if (!shouldAttachToken) {
        return next(req);
    }

    const token = authService.accessToken;
    if (!token) {
        return next(req);
    }

    const authReq = req.clone({
        setHeaders: {
            Authorization: `Bearer ${token}`
        }
    });

    return next(authReq).pipe(
        catchError((err: HttpErrorResponse) => {
            if (err.status === 401) {
                return authService.refreshToken().pipe(
                    switchMap(() => {
                        const newToken = authService.accessToken;
                        if (newToken) {
                            const newReq = req.clone({
                                setHeaders: {
                                    Authorization: `Bearer ${newToken}`
                                }
                            });
                            return next(newReq);
                        } else {
                            authService.logout();
                            return throwError(() => err);
                        }
                    }),
                    catchError(() => {
                        authService.logout();
                        return throwError(() => err);
                    })
                );
            }
            return throwError(() => err);
        })
    );
};
